module.exports = __webpack_public_path__ + "img/icon-database.800e6351.svg";